import React from 'react';
import * as UI from './styled';

type PropsButton = {
    icon?: JSX.Element
} & React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>

const Button = ({ icon, ...rest }: PropsButton) => {
    return (
        <UI.Container>
            <button onClick={rest.onClick} className="btn btn-white btn-animate">
                {icon}
                <span>{rest.value}</span>
            </button>
        </UI.Container>
    );
}

export default Button;